import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {callOpenWorkOrderForSaleJet} from '../../../utilities/openWorkOrder';
import Config from '../../../Config';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
import {buildUrl} from '../../../utilities/StringHelpers/StringHelpers';
import {
  getSaleCatalogAsync,
  getSalePricesAsync,
  createSaleAsync,
  checkUserAsync,
  setSelectedProductsAsync,
  createOtpForNewCustomerAsync,
  getEMVStep1,
  getEMVStep2,
  checkFiberAddressInfraStructure,
  getAddressEntries,
  getCustomerAddresses,
  getTechnicianTimesAsync,
  getFirstTechnicianTimeAsync,
  createOtp,
  validateOtp,
  getDeliveryTimeSlots,
  emailIsExist,
  createWorkOrder,
  createLead,
  checkWhatsAppActivity,
  getPhoneNumbers,
  getPhoneNumberInfo,
  reservePhone,
  getPriceSim,
  getFullPrice,
} from './saleBlockAsyncThunk';
import {salePages} from './salePages';
import {EMPTY_STEP_BAR, applyPageNavigationState} from './Partials/PackageBar/saleStepBarHelpers';
import {infrastructure} from '../../../constans/salePackageEnum';
import {getEsimTypeCode, getSimTypeCode, isEsimType, isSimType} from '../../../utilities/domain/simTypeConstants';
import {buildAddonEntryPopupConfigFromEpiAddons} from './Partials/Addons/addonEntryPopupHelpers';

const initialState = {
  saleBlockData: {
    blockId: 0,
    offerName: '',
    salePackages: [],
    creditIndicatorLink: '',
    creditIndicatorTitle: '',
  },
  saleCatalog: {},
  saleType: '', //tv|app|cellular|internet|triple|landline
  orderType: 'provide', //provide|replace
  page: '',
  percent: '0',
  progressBarPoints: [],
  stepBar: EMPTY_STEP_BAR,
  flowType: '', //existsCustomer|newCustomer
  otpDetails: {numOfAttempts: 0, customerEmail: '', restrictedCodeRequired: false, restrictCodeError: ''},
  originalPrice: 0,

  isSubmit: false,
  isValid: false,
  errorPage: {isDisplay: false, id: 0, description: ''},
  errorText: '',
  isLoadingShoppingCart: false,
  personalInfo: {firstName: '', lastName: '', identity: '', email: '', subscriberNo: '', isReceivingAd: false, isReceivingBill: false},
  magicLinkParameters: null,
  isEmailAvailable: true,
  addressPage: {
    selectedAddress: {},
    selectedEntry: {},
  },
  userAddressPage: {
    userAddresses: [],
    selectedAddress: {},
    isSelectedSeparateInvoice: false,
  },
  userAddressForUpgradePage: {
    userAddresses: [],
    selectedAddress: {},
    isSelectedSeparateInvoice: false,
  },
  selectedPackage: {},
  paymentInfo: {iframeUrl: '', numberOfPayments: ''},
  hasUserToken: false,
  checkUserResponse: {},
  supplyType: '', //technician | delivery
  technician: {
    technicianTimes: [],
    selectedTechnicianTime: {},
    selectedTechnicianTimeDisplay: '',
    firstTechnicianTime: {},
    firstTechnicianTimeDisplay: '',
  },
  delivery: {titleDeliveryPage: '', selectedDeliveryDate: {}, selectedDeliveryTimeDisplay: '', selectedAddress: {}, timeSlots: []},
  orderNumber: '',
  isCellcomAppActive: false,
  resultByOrders: [],
  summaryDetails: {},
  isCalcSupplyMethod: false,
  technicianContact: {fullName: '', phoneNumber: ''},
  technicianPrice: 0,
  deliveryPrice: 0,

    cellular: {
        simPriceList: [],
        orders: [],
        cellularSettingsList: [],
        isDisplayDeliveryPage: false,
        isSelectedEsim: false,
        isSupplyByPost: false,
        upgradeDisplayList: [],
        displaySubscriberBasedPackage: false,
        ordersDetailsResults: {},
        shoppingCart: {},
        qrCodeDetails: null,
        selectedEsimLine:{}
    },

  converters: [],
  addons: [],
  premiumPackages: [],
  productWorldList: [],
  productsForUpgrade: [],
  superWifiList: [],
  selectedRouter: {},
  cancelRouter: {},
  selectedInternetSpeed: {},
  selectedSuperWifi: {},
  selectedAddOns: [],
  isSelectedSuperWifi: false,
  isSelectedSuperWifiLead: false,
  leadType: '',
  isOccupiedTechnicianSlot: false,
  isWhatsAppActive: false,
  totalPrice: 0,
  isDisplayShoppingCart: true,
  isShoppingCartOpen: false,
  shoppingCartPopupMode: 'cart',
  shoppingCart: {},
  familyMemberInfo: {},
  packageNotValidPopUp: false,
  identitySuccessPopup: { isDisplay: false, contactName: '' },
  internetExistingInternetChoicePopup: { isDisplay: false },
  isShowPopUpRouterSlice: false,
  additionalResultValues: {},
  autoPrepareSale: false,
};

const saleJetBlockSlice = createSlice({
  name: 'saleJetBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initSale: {
      reducer: (state, action) => {
        state.saleBlockData = action.payload.saleBlockData;
        state.maximumConverters = action.payload.maximumConverters;
        state.page = action.payload.page;
        state.saleType = action.payload.saleType;
        state.flowType = action.payload.flowType;
        state.progressBarPoints = action.payload.progressBarPoints;
        state.hasUserToken = action.payload.hasUserToken;
        state.selectedPackage = action.payload.selectedPackage;
        state.addressPage = action.payload.addressPage;
        state.creditIndicatorLink = action.payload.creditIndicatorLink;
        state.creditIndicatorTitle = action.payload.creditIndicatorTitle;
        state.autoPrepareSale = !!action.payload.autoPrepareSale;
        applyPageNavigationState(state, state.page);
      },
      prepare: (action) => {
        let payload = {};
        const saleJetBlock = action.saleJetBlock;
        const saleType = getSaleTypeName(saleJetBlock.saleType.value);
        let saleBlockData = {
          blockId: saleJetBlock.contentLink.id,
          urlPackageNotMatch: saleJetBlock.urlPackageNotMatch?.value,
          // urlPackagesMaxSpeed1000: saleJetBlock.urlPackagesMaxSpeed1000.value,
          // urlPackagesSpeed1000: saleJetBlock.urlPackagesSpeed1000.value,
          // urlPackagesMaxSpeed2500: saleJetBlock.urlPackagesMaxSpeed2500.value,
          // urlXgsponPackagesMaxSpeed2500: saleJetBlock.urlXgsponPackagesMaxSpeed2500?.value,
          maximumConverters: Config.maximumConverters,
          salePackages: saleJetBlock.salePackages,
          converterImage: saleJetBlock.converterImage.value?.url,
          converterPopupText: saleJetBlock.converterPopupText.value,
          convertersInfoPopupText: saleJetBlock.convertersInfoPopupText.value,
          supportedTvImage: saleJetBlock.supportedTvImage.value?.url,
          supportedTvPopupText: saleJetBlock.supportedTvPopupText.value,
          routerImage: saleJetBlock.routerImage.value?.url,
          routerPopupText: saleJetBlock.routerPopupText.value,
          superWifiImage: saleJetBlock.superWifiImage.value?.url,
          superWifiPopupText: saleJetBlock.superWifiPopupText.value,
          isDisplaySuperWifi: !!saleJetBlock.isDisplaySuperWifi.value,
          isAllowReplace: !!saleJetBlock.isAllowReplace.value,
          isStartFromAddressPage: !!saleJetBlock.isStartFromAddressPage.value,
          isDisplayWhatsAppWhenNoFiber: !!saleJetBlock.isDisplayWhatsAppWhenNoFiber.value,
          urlToChangePackage: buildUrl(saleJetBlock.urlToChangePackage?.value),
          urlNiudEsimPage: buildUrl(saleJetBlock.urlNiudEsimPage?.value),

          // termsLink: saleJetBlock.termsLink?.value,
          // privacyPolicyLink: saleJetBlock.privacyPolicyLink?.value,
          //programDetailsLink: buildUrl(saleJetBlock.programDetailsLink?.value),
          //connectionAgreementLink: buildUrl(saleJetBlock.connectionAgreementLink?.value),
          generalTermsAgreementLink: buildUrl(saleJetBlock.generalTermsAgreementLink?.value),
          advertisingInfoLink: buildUrl(Config.advertisingInfoLink),

          pavingFeePopupText: saleJetBlock.pavingFeePopupText.value,
          pavingFeeTooltipText: saleJetBlock.pavingFeeTooltipText.value,
          noFiberCampaignCode: saleJetBlock.noFiberCampaignCode.value,
          noFiberCampaignName: saleJetBlock.noFiberCampaignName.value,
          noFiberProductId: saleJetBlock.noFiberProductId.value,
          mapaCampaignCode: saleJetBlock.mapaCampaignCode.value,
          mapaCampaignName: saleJetBlock.mapaCampaignName.value,
          mapaProductId: saleJetBlock.mapaProductId.value,
          superWifiCampaignCode: saleJetBlock.superWifiCampaignCode.value,
          superWifiCampaignName: saleJetBlock.superWifiCampaignName.value,
          superWifiProductId: saleJetBlock.superWifiProductId.value,
          creditIndicatorLink: saleJetBlock.creditIndicatorLink.value,
          creditIndicatorTitle: saleJetBlock.creditIndicatorTitle.value,
          esimData: saleJetBlock.esimData?.value ? saleJetBlock.esimData?.expandedValue[0] : null,
          urlActivateEsimPage: saleJetBlock.urlActivateEsimPage.value,
          isHidePremiumPackagesPage: !!saleJetBlock.isHidePremiumPackagesPage.value,
          textsaleType: saleJetBlock.textsaleType?.value,
          noFiberLeadSubtitle: saleJetBlock.noFiberLeadSubtitle?.value,
          internetCustomerInfoTitle: saleJetBlock.internetCustomerInfoTitle?.value,
          internetCustomerInfoSubtitle: saleJetBlock.internetCustomerInfoSubtitle?.value,
        };
        const salePackage = action.salePackage;
        const hasSelectedPackage = salePackage && Object.keys(salePackage).length > 0;
        const hasAddressPage = action.addressPage && Object.keys(action.addressPage.selectedAddress).length > 0;
        let selectedPackage = {};
        let addressPage = {
          selectedAddress: {},
          selectedEntry: {},
        };

        let page = 'packagesPage';
        // landline is a catalog hub: always start on packagesPage as newCustomer
        const isLandlineSale = saleType === 'landline';

        //--------- checkForSelectedAddress ---------
        if (hasAddressPage) {
          addressPage = action.addressPage;
        }
        //--------- checkForSelectedAddress ---------

        //--------- checkForSelectedPackage ---------
        if (hasSelectedPackage && !isLandlineSale) {
          const title = salePackage.title.trim().replace(/<[^>]+>/g, '');
          selectedPackage.offerId = salePackage.offerID;
          selectedPackage.saleType = salePackage.saleType;
          selectedPackage.title = title;
          selectedPackage.infrastructures = salePackage.infrastructures;
          selectedPackage.isXgspon = salePackage.isXgspon;
          selectedPackage.downloadSpeed = salePackage.downloadSpeed ? parseInt(salePackage.downloadSpeed) : 0;
          selectedPackage.uploadSpeed = salePackage.uploadSpeed ? parseInt(salePackage.uploadSpeed) : 0;
          selectedPackage.isSelectedCellcomRouter = salePackage.isSelectedCellcomRouter;
          selectedPackage.selectedRouterName = salePackage.isSelectedCellcomRouter
            ? salePackage.routerInfo?.cellcomRouterName?.value
            : salePackage.routerInfo?.foreignRouterName?.value;
          selectedPackage.defaultConvertersAmount = salePackage.defaultConvertersAmount;
          selectedPackage.minimumConvertersAmount = salePackage.minimumConvertersAmount;
          selectedPackage.programDetailsLink = salePackage.programDetailsLink;
          selectedPackage.connectionAgreementLink = salePackage.connectionAgreementLink;
          selectedPackage.addons = salePackage.addons?.map((x) => x.id.value);
          selectedPackage.addonsEntryPopupConfig = buildAddonEntryPopupConfigFromEpiAddons(salePackage.addons);
          selectedPackage.isCustomerBasedPackage = salePackage.isCustomerBasedPackage;
          selectedPackage.isDisplayEsim = salePackage.isDisplayEsim;
          selectedPackage.isBenefitsForSoldiers = salePackage.isBenefitsForSoldiers;
          selectedPackage.fileUpload = salePackage.fileUpload;
          selectedPackage.upgradeDetails = salePackage.upgradeDetails;
          selectedPackage.isFamilyPackage = salePackage.isFamilyPackage;
          selectedPackage.familyPackageSapFields = salePackage.familyPackageSapFields;
          selectedPackage.isDisplayUpgradePopUp = false;
          selectedPackage.routerInfo = salePackage.routerInfo;
          selectedPackage.isShowPopUpEpi = salePackage.isShowPopUpEpi;
          selectedPackage.isImmediateTransitionPlan = salePackage.isImmediateTransitionPlan;
          selectedPackage.couponList = salePackage.couponList;
          if (saleType == 'tv' || saleType == 'app' || saleType == 'cellular' || (hasAddressPage && saleType !== 'internet')) {
            page = 'loginPage';
            if (action.isFullAuthenticated) {
              page = 'loginSuccessPage';
            }
          } else if (saleType === 'internet' && hasAddressPage) {
            if (action.isFullAuthenticated) {
              page = 'loginSuccessPage';
            } else {
              page = 'packagesPage';
              payload.autoPrepareSale = true;
            }
          } else {
            page = 'addressPage';
          }
        }
        //--------- checkForSelectedPackage ---------

        if ((saleType == 'internet' || saleType == 'triple') && saleBlockData.isStartFromAddressPage && !hasAddressPage) {
          page = 'addressPage';
        }

        if (isLandlineSale) {
          page = 'packagesPage';
        }

        payload.saleBlockData = saleBlockData;
        payload.page = page;
        payload.saleType = saleType;
        payload.flowType = 'newCustomer';
        payload.progressBarPoints = getProgressBarPoints(saleType, payload.flowType);
        payload.hasUserToken = !!authenticationProvider.getSavedToken();
        payload.selectedPackage = selectedPackage;
        payload.addressPage = addressPage;
        return {payload: payload};
      },
    },
    syncPageNavigationState: (state) => {
      applyPageNavigationState(state, state.page);
    },
    setIsSubmit: (state, action) => {
      state.isSubmit = action.payload;
    },
    clearAutoPrepareSale: (state) => {
      state.autoPrepareSale = false;
    },
    goToPage: (state, action) => {
      state.page = action.payload;
      applyPageNavigationState(state, action.payload);

      if (action.payload == 'summaryPage') {
        const summaryDetails = buildSummaryDetails(state);
        state.summaryDetails = summaryDetails;
      }

      if (action.payload == 'createSaleInProcess') {
        state.isDisplayShoppingCart = false;
      }

      window.scrollTo(0, 0);
    },
    setSaleType: (state, action) => {
      state.saleType = action.payload;
      state.progressBarPoints = getProgressBarPoints(state.saleType, state.flowType);
      applyPageNavigationState(state, state.page);
    },
    setShowPopUpRouter: (state, action) => {
      state.isShowPopUpRouterSlice = action.payload;
    },
    setFlowType: (state, action) => {
      state.flowType = action.payload;
      state.progressBarPoints = getProgressBarPoints(state.saleType, state.flowType);
      applyPageNavigationState(state, state.page);
    },
    setOrderType: (state, action) => {
      state.orderType = action.payload;
    },
    setUserAddressesForUpgrade: (state, action) => {
      const userAddresses = action.payload.bansForReplace;
      state.userAddressForUpgradePage.userAddresses = userAddresses;
    },
    setIsLoadingShoppingCart: (state, action) => {
      state.isLoadingShoppingCart = action.payload;
    },
    reportAnalytics: (state, action) => {},
    reportTagManager: (state, action) => {},
    setErrorPage: (state, action) => {
      state.errorPage.isDisplay = action.payload.isDisplay;
      state.errorPage.id = parseInt(action.payload.id, 10);
      state.errorPage.description = action.payload.description;
      if (action.payload.isOpenWorkOrder) {
        callOpenWorkOrderForSaleJet(state);
      }
      state.page = 'errorPage';
      applyPageNavigationState(state, 'errorPage');
    },
    setLeadPage: (state, action) => {
      state.leadType = action.payload;
      state.page = 'leadPage';
      applyPageNavigationState(state, 'leadPage');
    },
    setErrorText: (state, action) => {
      state.errorText = action.payload;
    },
    setOtpDetails: (state, action) => {
      state.otpDetails.otpTicketId = action.payload.otpTicketId;
      state.otpDetails.otpPhone = action.payload.otpPhone;
      state.otpDetails.otpIdentity = action.payload.otpIdentity;
      state.otpDetails.otpFlow = action.payload.otpFlow;
      state.otpDetails.customerEmail = action.payload.customerEmail ?? '';
      state.otpDetails.needsPaymentDigits = Boolean(action.payload.needsPaymentDigits);
      state.otpDetails.restrictedCodeRequired = Boolean(action.payload.restrictedCodeRequired);
      state.otpDetails.restrictCodeError = '';
      state.otpDetails.errorMsg = '';
    },
    setSelectedAddress: (state, action) => {
      state.addressPage.selectedAddress = action.payload;
    },
    updateConverter: (state, action) => {
      let converters = state.converters;
      let converter = converters.find((x) => x.name == action.payload.name);

      if (converter) {
        converter.count = action.payload.count;
        state.converters = converters;
      } else {
        const newConverter = {name: action.payload.name, count: action.payload.count};
        state.converters.push(newConverter);
      }
    },
    updateAddons: (state, action) => {
      let addon = state.selectedAddOns?.find((x) => x.name == action.payload.name);
      if (addon) {
        addon.count = action.payload.count;
      } else {
        const newAddon = {name: action.payload.name, count: action.payload.count};
        state.selectedAddOns.push(newAddon);
      }
    },
    setOtpAttempts: (state, action) => {
      state.otpDetails.numOfAttempts = state.otpDetails.numOfAttempts + 1;
    },
    setOtpTicketId: (state, action) => {
      state.otpDetails.otpTicketId = action.payload.otpTicketId;
    },
    setOtpErrorMsg: (state, action) => {
      state.otpDetails.errorMsg = action.payload;
    },
    setOtpRestrictCodeError: (state, action) => {
      state.otpDetails.restrictCodeError = action.payload;
    },
    setTechnicianDay: (state, action) => {
      state.technician.technicianTimes.map(function (x) {
        if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
          x.isSelected = true;
          if (x.hours && x.hours.length > 0) {
            x.hours[0].isSelected = true;
          }
        } else {
          x.isSelected = false;
        }
        return x;
      });

      const selectedTechnicianTime = {
        year: action.payload.year,
        month: action.payload.month,
        day: action.payload.day,
        startDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].startDate : '',
        endDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].endDate : '',
      };
      state.technician.selectedTechnicianTime = selectedTechnicianTime;
      state.technician.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(
        selectedTechnicianTime.startDate,
        selectedTechnicianTime.endDate,
      );
    },
    setTechnicianSelectedTime: (state, action) => {
      state.technician.technicianTimes.map(function (x) {
        if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
          x.hours.map(function (hour) {
            if (hour.startDate == action.payload.startDate) {
              hour.isSelected = true;
            } else {
              hour.isSelected = false;
            }
            return hour;
          });
        }
        return x;
      });
      state.technician.selectedTechnicianTime = action.payload;
      state.technician.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(action.payload.startDate, action.payload.endDate);
    },
    setEntries: (state, action) => {
      state.addressPage.entries = action.payload;
    },
    setSelectedEntry: (state, action) => {
      state.addressPage.selectedEntry = action.payload;
      state.addressPage.selectedAddress.entry = action.payload.entry;
    },
    setSelectedRouter: (state, action) => {
      state.selectedRouter = {name: action.payload.name, count: 1};
    },
    setCancelRouter: (state, action) => {
      state.selectedRouter = {name: action.payload.name, count: 0};
    },
    setSelectedInternetSpeed: (state, action) => {
      state.selectedInternetSpeed = {name: action.payload.name, count: 1};
    },
    setSelectedSuperWifi: (state, action) => {
      if (!action.payload) {
        return;
      }

      if (action.payload.name != '') {
        state.selectedSuperWifi = {name: action.payload.name, count: 1};
      } else {
        state.selectedSuperWifi = {};
      }
      state.isSelectedSuperWifi = true;
    },
    setSelectedSuperWifiReplace: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.isSelectedSuperWifi = true;
      state.isSelectedSuperWifiLead = action.payload.name == 'lead';
    },
    setPersonalInfo: (state, action) => {
      state.personalInfo.isCustomerExists = action.payload.isCustomerExists
        ? action.payload.isCustomerExists
        : state.personalInfo.isCustomerExists;
      state.personalInfo.identity = action.payload.identity ? action.payload.identity : state.personalInfo.identity;
      state.personalInfo.subscriberNo = action.payload.subscriberNo ? action.payload.subscriberNo : state.personalInfo.subscriberNo;
      state.personalInfo.firstName = action.payload.firstName ? action.payload.firstName : state.personalInfo.firstName;
      state.personalInfo.lastName = action.payload.lastName ? action.payload.lastName : state.personalInfo.lastName;
      state.personalInfo.email = action.payload.email ? action.payload.email : state.personalInfo.email;
      state.personalInfo.isReceivingAd = !!action.payload.isReceivingAd;
      state.personalInfo.isReceivingBill = !!action.payload.isReceivingBill;
    },
    setSelectedPackage: (state, action) => {
      const salePackage = action.payload;
      const equipmentAddon = salePackage.addons?.find((x) => x.id.value === 'MESH' || x.id.value === 'MESHUL' || x.id.value === 'MESHPR');
      const title = salePackage.title.trim().replace(/<[^>]+>/g, '');
      state.selectedPackage.offerId = salePackage.offerID;
      state.selectedPackage.saleType = salePackage.saleType;
      state.selectedPackage.title = title;
      state.selectedPackage.infrastructures = salePackage.infrastructures;
      state.selectedPackage.isXgspon = salePackage.isXgspon;
      state.selectedPackage.downloadSpeed = salePackage.downloadSpeed ? parseInt(salePackage.downloadSpeed) : 0;
      state.selectedPackage.uploadSpeed = salePackage.uploadSpeed ? parseInt(salePackage.uploadSpeed) : 0;
      state.selectedPackage.selectedRouterName = salePackage.selectedRouterName;
      state.selectedPackage.defaultConvertersAmount = salePackage.defaultConvertersAmount;
      state.selectedPackage.minimumConvertersAmount = salePackage.minimumConvertersAmount;
      state.selectedPackage.programDetailsLink = salePackage.programDetailsLink;
      state.selectedPackage.connectionAgreementLink = salePackage.connectionAgreementLink;
      state.selectedPackage.isSelectedCellcomRouter = salePackage.isSelectedCellcomRouter;
      state.selectedPackage.isCustomerBasedPackage = salePackage.isCustomerBasedPackage;
      state.selectedPackage.isDisplayEsim = salePackage.isDisplayEsim;
      state.selectedPackage.isBenefitsForSoldiers = salePackage.isBenefitsForSoldiers;
      state.selectedPackage.fileUpload = salePackage.fileUpload;
      state.selectedPackage.isImmediateTransitionPlan = salePackage.isImmediateTransitionPlan;
      state.selectedPackage.isFamilyPackage = salePackage.isFamilyPackage;
      state.selectedPackage.routerInfo = salePackage.routerInfo;
      state.selectedPackage.isShowPopUpEpi = salePackage.isShowPopUpEpi;
      state.familyPackageSapFields = salePackage.familyPackageSapFields;
      if (equipmentAddon && !salePackage.isSelectedCellcomRouter) {
        state.selectedPackage.addons = salePackage.addons
          ?.filter((x) => x.id.value !== 'MESH' && x.id.value !== 'MESHUL' && x.id.value !== 'MESHPR')
          ?.map((x) => x.id.value);
      } else {
        state.selectedPackage.addons = salePackage.addons?.map((x) => x.id.value);
      }
      state.selectedPackage.addonsEntryPopupConfig = buildAddonEntryPopupConfigFromEpiAddons(salePackage.addons);
      state.selectedPackage.upgradeDetails = salePackage.upgradeDetails;
      state.selectedPackage.isDisplayUpgradePopUp = false;
      state.selectedPackage.couponList = salePackage.couponList;
    },
    setUserAddresses: (state, action) => {
      state.userAddressPage.userAddresses = action.payload;
    },
    setSelectedUserAddress: (state, action) => {
      state.userAddressPage.selectedAddress = action.payload.address;
      state.userAddressPage.isSelectedSeparateInvoice = action.payload.isSelectedSeparateInvoice;
    },
    setSelectedUserAddressForUpgrade: (state, action) => {
      state.userAddressForUpgradePage.selectedAddress = action.payload.address;
      state.userAddressForUpgradePage.isSelectedSeparateInvoice = action.payload.isSelectedSeparateInvoice;
    },
    setPremiumPackageChanged: (state, action) => {
      if (action.payload.isSelected) {
        if (action.payload.premiumPackage.isPremiumPackagesWorld) {
          const checked = action.payload.premiumPackage.premiumPackages.filter((premium) =>
            action.payload.vasList.find((x) => x == premium.name),
          );
          checked?.map((vas, index) => {
            const existVas = state.premiumPackages?.find((x) => x.name == vas.name);
            if (!existVas) {
              state.premiumPackages?.push({name: vas.name, count: 1});
            } else {
              existVas.count = 1;
            }
          });
        } else {
          action.payload.vasList?.map((vas, index) => {
            const existVas = state.premiumPackages?.find((x) => x.name == vas);
            if (!existVas) {
              state.premiumPackages?.push({name: vas, count: 1});
            } else {
              existVas.count = 1;
            }
          });
        }
      } else if (!action.payload.isSelected) {
        action.payload.vasList?.map((vas, index) => {
          const existVas = state.premiumPackages?.find((x) => x.name == vas);
          if (!existVas) {
            state.premiumPackages?.push({name: vas, count: 0});
          } else {
            existVas.count = 0;
          }
        });
      }
    },
    resetPremiumPackage: (state, action) => {
      state.premiumPackages = state.premiumPackages?.filter((item) => {
        if (item.count == 0) {
          const existPack = state.saleCatalog.premiumPackages.find((x) => x.name == item.name);
          if (existPack) {
            return existPack.defaultNumber == 1;
          }
        } else {
          return true;
        }
      });
    },
    setEmail: (state, action) => {
      state.personalInfo.email = action.payload;
    },
    setIsEmailAvailable: (state, action) => {
      state.isEmailAvailable = action.payload;
    },
    resetCgIframeUrl: (state, action) => {
      state.paymentInfo.iframeUrl = null;
    },
    setSupplyType: (state, action) => {
      state.supplyType = action.payload;
      state.technician.selectedTechnicianTimeDisplay = '';
      state.delivery.selectedDeliveryTimeDisplay = '';
    },
    setTechnicianPrice: (state, action) => {
      state.technicianPrice = parseFloat(action.payload);
    },
    setDeliveryPrice: (state, action) => {
      state.deliveryPrice = parseFloat(action.payload);
    },
    setDeliveryAddress: (state, action) => {
      state.delivery.selectedAddress = action.payload;
    },
    setSelectedDeliveryDay: (state, action) => {
      state.delivery.timeSlots.map(function (x) {
        if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
          x.isSelected = true;
          if (x.hours && x.hours.length > 0) {
            x.hours[0].isSelected = true;
          }
        } else {
          x.isSelected = false;
        }
        return x;
      });

      const selectedDeliveryDate = {
        year: action.payload.year,
        month: action.payload.month,
        day: action.payload.day,
        startDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].startDate : '',
        endDate: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].endDate : '',
        round: action.payload.hours && action.payload.hours.length > 0 ? action.payload.hours[0].round : '',
      };
      state.delivery.selectedDeliveryDate = selectedDeliveryDate;
      state.delivery.selectedDeliveryTimeDisplay = getTechnicianTimeDisplay(selectedDeliveryDate.startDate, selectedDeliveryDate.endDate);
    },
    setSelectedDeliveryTime: (state, action) => {
      state.delivery.timeSlots.map(function (x) {
        if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
          x.hours.map(function (hour) {
            if (hour.startDate == action.payload.startDate) {
              hour.isSelected = true;
            } else {
              hour.isSelected = false;
            }
            return hour;
          });
        } else {
          x.hours.map(function (hour) {
            hour.isSelected = false;
            return hour;
          });
        }
        return x;
      });
      state.delivery.selectedDeliveryDate = action.payload;
      state.delivery.selectedDeliveryTimeDisplay = getTechnicianTimeDisplay(action.payload.startDate, action.payload.endDate);
    },
    setIsReceivingAd: (state, action) => {
      state.personalInfo.isReceivingAd = action.payload;
    },
    setIsCalcSupplyMethod: (state, action) => {
      state.isCalcSupplyMethod = action.payload;
    },
    setTechnicianContact: (state, action) => {
      state.technicianContact = action.payload;
    },
    // filterSalePackages: (state, action) => {
    //   if (!state.saleBlockData.salePackages || !state.saleBlockData.salePackages.expandedValue) {
    //     return;
    //   }
    //   const infrastructure = state.addressPage.selectedEntry?.infrastructure;
    //   const infrastructureEnums = { 0: 'FB', 1: 'BF', 2: 'BC' };
    //   let salePackages = { expandedValue: [] };

    //   state.saleBlockData.salePackages.expandedValue.forEach((item) => {
    //     const infrastructureList =
    //       item.infrastructures?.value?.map((item) => {
    //         return infrastructureEnums[item.infrastructure];
    //       }) ?? [];
    //     if (infrastructureList.includes(infrastructure)) {
    //       salePackages.expandedValue.push(item);
    //     }
    //   })
    //   state.saleBlockData.salePackages = salePackages;
    // },
    reportDWH: (state, action) => {},
    setIsOccupiedTechnicianSlot: (state, action) => {
      state.isOccupiedTechnicianSlot = action.payload;
    },
    setTotalPrice: (state, action) => {
      state.totalPrice = action.payload;
    },
    setSalePackages: (state, action) => {
      state.saleBlockData.salePackages = {
        expandedValue: action.payload,
      };
    },
    setPackageNotValidPopUp: (state, action) => {
      state.packageNotValidPopUp = action.payload;
    },
    setIdentitySuccessPopup: (state, action) => {
      state.identitySuccessPopup = {
        isDisplay: Boolean(action.payload?.isDisplay),
        contactName: action.payload?.contactName || '',
      };
    },
    setInternetExistingInternetChoicePopup: (state, action) => {
      state.internetExistingInternetChoicePopup = {
        isDisplay: Boolean(action.payload?.isDisplay),
      };
    },
    resetCellularSettingsPage: (state, action) => {
      state.selectedAddOns = [];
      state.cellular.displaySubscriberBasedPackage = false;
      if (action.payload.isFullReset) {
        state.cellular.cellularSettingsList = [];
        state.cellular.isDisplayDeliveryPage = false;
        state.cellular.orders = [];
        state.cellular.ordersDetailsResults = {};
      } else {
        state.cellular.cellularSettingsList.map((item) => {
          item.isSelected = false;
          return item;
        });
      }

      let packageObj = {title: '', offerId: '', isDisplayFileUpload: false, couponList: []};
      if (!action.payload.isResetPackage) {
        const packageTitle = state.selectedPackage.title.replace(/<[^>]+>/g, '');
        packageObj = {
          title: packageTitle,
          offerId: state.selectedPackage.offerId,
          isDisplayFileUpload: state.selectedPackage.isBenefitsForSoldiers,
          fileUpload: state.selectedPackage.fileUpload,
          couponList: state.selectedPackage.couponList,
        };
      }

      const isRemovableFromBanner = state.cellular.cellularSettingsList?.length >= 1;

      let cellularSetting = {
        step: 1,
        isSelected: true,
        isRemovableFromBanner: isRemovableFromBanner,
        phoneType: '',
        phoneNumber: '',
        isValidPhoneNumber: false,
        simType: '',
        cellularServices: resetCellularServices(),
        cellularServicesCodes: buildCellularServicesCodes(null),
        showPackages: false,
        package: packageObj,
        orderId: '',
        bpKey: state.saleCatalog?.bpKey,
        selectedAddOns: [],
        newPhoneNumbers: [],
        transferPhoneNumberInfo: {isCellcomPhone: false, isGolanPhone: false},
        reservePhoneInfo: {},
        price: state.saleCatalog.price,
        originalPrice: state.saleCatalog.originalPrice,
        priceItemList: buildPriceItemList(state.saleCatalog.priceItemList),
        change: {
          originalPhoneNumber: '',
          action: '',
        },
        setNewChanges: false,
      };
      state.cellular.cellularSettingsList.push(cellularSetting);
      window.scrollTo(0, 0);
    },
    setCellularSetting: (state, action) => {
      let current = state.cellular.cellularSettingsList.find((x) => x.isSelected);
      current.step = action.payload.step ?? current.step;
      current.phoneType = action.payload.phoneType ?? current.phoneType;
      current.simType = action.payload.simType ?? current.simType;
      current.isValidPhoneNumber = action.payload.isValidPhoneNumber ?? current.isValidPhoneNumber;
      current.showPackages = action.payload.showPackages ?? false;
      const phoneNumber = action.payload.phoneNumber;
      if (phoneNumber) {
        current.phoneNumber = phoneNumber;
        current.phoneNumberFormat = phoneNumber;
        if (phoneNumber?.length >= 3) {
          current.phoneNumberFormat = phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3);
        }
      } else if (phoneNumber == '') {
        current.phoneNumber = '';
        current.phoneNumberFormat = '';
      }
      if (action.payload.setNewPackage) {
        const packageTitle = state.selectedPackage.title.replace(/<[^>]+>/g, '');
        const packageObj = {
          title: packageTitle,
          offerId: state.selectedPackage.offerId,
          isDisplayFileUpload: state.selectedPackage.isBenefitsForSoldiers,
          fileUpload: state.selectedPackage.fileUpload,
          couponList: state.selectedPackage.couponList,
        };
        current.package = packageObj;
      }
      if (current.orderId != '') {
        current.setNewChanges = true;
      }
    },
    setCellularSettingList: (state, action) => {
      const hasSim = state.cellular.cellularSettingsList.find((x) => isSimType(x.simType));
      let current = state.cellular.cellularSettingsList.find((x) => x.isSelected);
      state.cellular.isDisplayDeliveryPage = hasSim ? true : false;
      const order = state.saleCatalog?.orders?.find((x) => x.orderType == current.simType);
      if (action.payload.action == 'Add') {
        // const isExist = state.cellular.orders.find(x => x.orderId == order?.orderId);
        // if (!isExist) {
        //   state.cellular.orders.push(order);
        // }
        current.step = 4;
        (current.isRemovableFromBanner = false), (current.change.action = 'Change');
        current.change.originalPhoneNumber = current.phoneNumber;
        current.selectedAddOns = state.selectedAddOns;
        current.orderId = order?.orderId;
        current.bpKey = state.saleCatalog?.bpKey;
      } else if (action.payload.action == 'Change') {
        current.change.action = 'Change';
        current.orderId = order?.orderId;
        current.setNewChanges = false;
        current.selectedAddOns = state.selectedAddOns;
      } else if (action.payload.action == 'Disconnect') {
        state.cellular.cellularSettingsList = state.cellular.cellularSettingsList.filter((x) => !x.isSelected);
      }
      const isSelectedEsim = state.cellular.cellularSettingsList?.some((x) => isEsimType(x.simType));
      state.cellular.isSelectedEsim = isSelectedEsim;
    },
    setSelectedAddOn: (state, action) => {
      let selectedAddon = state.addons.find((x) => x.name == action.payload.item.name);
      const count = action.payload.count;
      if (action.payload.isSelected) {
        if (!selectedAddon) {
          state.addons.push({name: action.payload.item.name, count: count});
        } else {
          selectedAddon.count = count;
        }
      } else {
        if (!selectedAddon) {
          state.selectedAddOns?.push({name: action.payload.item.name, count: count});
        } else {
          selectedAddon.count = count;
        }
      }
      const isMandatory = action.payload.item.defaultNumber != 0;
      const lowerLimit = action.payload.item.lowerLimit;

      if (!isMandatory && lowerLimit == count) {
        state.selectedAddOns = state.selectedAddOns.filter((x) => x.name != action.payload.item.name);
      }
    },
    setCellularServices: (state, action) => {
      let selectedCellular = state.cellular.cellularSettingsList.find((x) => x.isSelected);
      selectedCellular.cellularServices = action.payload;
      selectedCellular.cellularServicesCodes = buildCellularServicesCodes(action.payload);
    },
    onClickCellularItem: (state, action) => {
      state.cellular.cellularSettingsList.map((item, index) => {
        if (item.phoneNumber == action.payload.phoneNumber && index == action.payload.index) {
          item.isSelected = true;
          state.selectedAddOns = item.selectedAddOns;
        } else {
          item.isSelected = false;
        }
      });
    },
    setIsDisplayPackageUpgradePopUp: (state, action) => {
      state.selectedPackage.isDisplayUpgradePopUp = action.payload;
    },
    resetCellularTransferPhoneNumberInfo: (state, action) => {
      let current = state.cellular.cellularSettingsList.find((x) => x.isSelected);
      current.transferPhoneNumberInfo.isCellcomPhone = false;
      current.transferPhoneNumberInfo.isGolanPhone = false;
    },
    updateSelectedCellularSettings: (state, action) => {
      let current = state.cellular.cellularSettingsList.find((x) => x.isSelected);
      const packageTitle = state.selectedPackage.title.replace(/<[^>]+>/g, '');
      current.package = {
        title: packageTitle,
        offerId: state.selectedPackage.offerId,
        isDisplayFileUpload: state.selectedPackage.isBenefitsForSoldiers,
      };
      current.bpKey = state.saleCatalog?.bpKey;
      current.price = state.saleCatalog.price;
      current.originalPrice = state.saleCatalog.originalPrice;
      current.priceItemList = buildPriceItemList(state.saleCatalog.priceItemList);
    },
    setSupplyByPost: (state, action) => {
      state.cellular.isSupplyByPost = action.payload;
    },
    setDisplaySubscriberBasedPackage: (state, action) => {
      state.cellular.displaySubscriberBasedPackage = action.payload;
    },
    setResultByOrders: (state, action) => {
      const resultByOrders = action.payload;
      const failureOrder = resultByOrders?.find((x) => !x.isSuccess);
      state.resultByOrders = resultByOrders;
      const succsessPhoneNumbers = failureOrder ? state.cellular?.cellularSettingsList?.filter(x => x.orderId != failureOrder.orderId) : state.cellular?.cellularSettingsList;
      state.cellular.ordersDetailsResults.hasESimWithTransferLine = succsessPhoneNumbers?.some(x => isEsimType(x.simType) && x.phoneType == "transfer");
      state.cellular.ordersDetailsResults.hasESimWithNewLine = succsessPhoneNumbers?.some(x => isEsimType(x.simType) && x.phoneType == "new");
      state.cellular.ordersDetailsResults.hasSim = succsessPhoneNumbers?.some(x => isSimType(x.simType));
      state.cellular.ordersDetailsResults.hasESim = succsessPhoneNumbers?.some(x => isEsimType(x.simType));
      state.cellular.ordersDetailsResults.hasFailureOrder = failureOrder ? true : false;
      state.cellular.ordersDetailsResults.simTypeSuccess = failureOrder ? succsessPhoneNumbers[0].simType : '';
      state.cellular.ordersDetailsResults.failurePhoneNumbers = failureOrder
        ? state.cellular?.cellularSettingsList?.filter((x) => x.orderId == failureOrder.orderId)?.map((x) => x.phoneNumberFormat)
        : [];
    },
    setSummaryDetails: (state, action) => {
      const summaryDetails = buildSummaryDetails(state);
      state.summaryDetails = summaryDetails;
    },
    editRemoveCellular: (state, action) => {
      state.cellular.cellularSettingsList.map((item) => {
        item.isSelected = false;
        item.change = {originalPhoneNumber: '', action: ''};
        return item;
      });
      let current = state.cellular.cellularSettingsList.find((x) => x.phoneNumber == action.payload.phoneNumber);
      current.isSelected = true;
      current.change.originalPhoneNumber = action.payload.phoneNumber;
      current.change.action = action.payload.action;
      if (action.payload.action == 'Change') {
        state.selectedAddOns = current.selectedAddOns;
      }
    },
    removeCellularItem: (state, action) => {
      state.cellular.cellularSettingsList = state.cellular.cellularSettingsList.filter((x) => x.phoneNumber != action.payload.phoneNumber);
      const lastIndex = state.cellular.cellularSettingsList.length - 1;
      let current = state.cellular.cellularSettingsList[lastIndex];
      current.isSelected = true;
      state.selectedAddOns = current.selectedAddOns;
      const isSelectedEsim = state.cellular.cellularSettingsList?.some((x) => isEsimType(x.simType));
      state.cellular.isSelectedEsim = isSelectedEsim;
    },
    setIsDisplayShoppingCart: (state, action) => {
      state.isDisplayShoppingCart = action.payload;
    },
    setIsShoppingCartOpen: (state, action) => {
      if (typeof action.payload === 'object') {
        state.isShoppingCartOpen = action.payload.isOpen;
        if (action.payload.mode) {
          state.shoppingCartPopupMode = action.payload.mode;
        }
        if (!action.payload.isOpen) {
          state.shoppingCartPopupMode = 'cart';
        }
        return;
      }

      state.isShoppingCartOpen = action.payload;
      if (action.payload) {
        state.shoppingCartPopupMode = 'cart';
      } else {
        state.shoppingCartPopupMode = 'cart';
      }
    },
    setProductWorldList: (state, action) => {
      let premiumPackageWorld = state.productWorldList.find((x) => x.name == action.payload.world);
      if (!premiumPackageWorld) {
        state.productWorldList.push({
          name: action.payload.world,
          productList: [{name: action.payload.packageName, count: action.payload.count}],
        });
      } else {
        let premiumPackage = premiumPackageWorld.productList.find((x) => x.name == action.payload.packageName);
        if (premiumPackage) {
          premiumPackage.count = action.payload.count;
        } else {
          premiumPackageWorld.productList.push({name: action.payload.packageName, count: action.payload.count});
        }
      }
    },
    removeProductWorldListEntry: (state, action) => {
      const world = state.productWorldList.find((x) => x.name == action.payload.world);
      if (world) {
        world.productList = world.productList.filter((x) => x.name !== action.payload.packageName);
      }
    },
    setFamilyMemberInfo: (state, action) => {
      state.familyMemberInfo = action.payload;
    },
    setSelectedEsimLine: (state, action) => {
      state.cellular.selectedEsimLine = action.payload;
    },
    setAdditionalResultValue: (state, action) => {
      state.additionalResultValues = action.payload;
    }
  },
  extraReducers: {
    [getSaleCatalogAsync.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.saleCatalog || !action.payload.saleCatalog.isSuccess) {
        return;
      }
      state.saleCatalog = action.payload.saleCatalog;
      state.saleCatalog.premiumPackages = getAllPremiumPackages(action.payload.saleCatalog);
      state.offerName = action.payload.saleCatalog?.offerName;
      state.originalPrice = parseFloat(action.payload.saleCatalog?.price);
    },
    [getSalePricesAsync.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.saleCatalog) {
        return;
      }

      if (state.saleType == 'cellular') {
        let current = state.cellular?.cellularSettingsList?.find((x) => x.isSelected);
        // if (current.change.action == 'Disconnect') {
        //   state.cellular.orders = action.payload.saleCatalog.orders;
        // }
        // else {
        //   state.saleCatalog = action.payload.saleCatalog;
        // }
        current.change = {originalPhoneNumber: '', action: ''};
        state.cellular.orders = action.payload.saleCatalog.orders;
        state.saleCatalog = action.payload.saleCatalog;
      } else {
        state.saleCatalog = action.payload.saleCatalog;
        state.saleCatalog.premiumPackages = getAllPremiumPackages(action.payload.saleCatalog);
        // const summaryDetails = buildSummaryDetails(state);
        // state.summaryDetails = summaryDetails;
      }
    },
    [createSaleAsync.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.orderNumber = action.payload.orderId;
      state.summaryDetails.orderNumber = action.payload.orderId;
      state.isCellcomAppActive = action.payload.isCellcomAppActive;
      state.resultByOrders = action.payload.resultByOrders;
      //const summaryDetails = buildSummaryDetails(state);
      //state.summaryDetails = summaryDetails;
    },
    [checkUserAsync.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.checkUserResponse = action.payload;
    },
    [getEMVStep1.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.paymentInfo.iframeUrl = action.payload.paymentCGUrl;
    },
    [getEMVStep2.fulfilled]: (state, action) => {
      if (action.payload.returnCode == '00') {
        if (action.payload.authNumber) {
          state.paymentInfo.confirmationNumber = action.payload.authNumber;
          state.paymentInfo.CardDueYear = action.payload.cardYear;
          state.paymentInfo.CardDueMonth = action.payload.cardMonth;
          state.paymentInfo.id = action.payload.id;
          state.paymentInfo.CGData = action.payload;
          state.paymentInfo.CCToken = action.payload.ccToken;
          state.paymentInfo.CCType = action.payload.ccType;
          state.paymentInfo.Credit4Digits = action.payload.credit4Digits;
          state.paymentInfo.paymentCount = action.payload.totalPayments;
          if (action.payload.cvv) state.paymentInfo.CCvv = action.payload.cvv;
        }
      }
    },
    [checkFiberAddressInfraStructure.fulfilled]: (state, action) => {},
    [getAddressEntries.fulfilled]: (state, action) => {},
    [getCustomerAddresses.fulfilled]: (state, action) => {},
    [getTechnicianTimesAsync.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      let technicianTimes = getCustomTechnicianTimes(action.payload);
      if (technicianTimes?.length > 0) {
        technicianTimes[0].isSelected = true;
        if (technicianTimes[0].hours?.length > 0) {
          technicianTimes[0].hours[0].isSelected = true;
        }
      }
      state.technician.technicianTimes = technicianTimes;

      const firstTechnicianTime = {
        startDate: technicianTimes[0].hours[0].startDate,
        endDate: technicianTimes[0].hours[0].endDate,
      };

      state.technician.firstTechnicianTime = firstTechnicianTime;
      state.technician.selectedTechnicianTime = firstTechnicianTime;
      state.technician.firstTechnicianTimeDisplay = getTechnicianTimeDisplay(
        technicianTimes[0].hours[0].startDate,
        technicianTimes[0].hours[0].endDate,
      );
      state.technician.selectedTechnicianTimeDisplay = getTechnicianTimeDisplay(
        technicianTimes[0].hours[0].startDate,
        technicianTimes[0].hours[0].endDate,
      );
    },
    [getFirstTechnicianTimeAsync.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.start) {
        return;
      }

      let startDate = new Date(action.payload.start);

      let today = new Date();
      let numberOfDays = daysBetweenTwoDates(startDate, today);
      if (numberOfDays >= Config.firstTechnicianRange) {
        return;
      }

      const firstTechnicianTime = {
        startDate: action.payload.start,
      };
      state.technician.firstTechnicianTime = firstTechnicianTime;
      state.technician.selectedTechnicianTime = firstTechnicianTime;
      state.technician.firstTechnicianTimeDisplay = getTechnicianTimeDisplay(action.payload.start, action.payload.end);
    },
    [createOtp.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      if (action.payload.step1Ticket) {
        state.otpDetails.otpTicketId = action.payload.step1Ticket;
      }
    },
    [validateOtp.fulfilled]: (state, action) => {},
    [getDeliveryTimeSlots.fulfilled]: (state, action) => {
      if (action.payload.errorCode) {
        return;
      }
      let timeSlots = deliveryTimeSlotsFormat(action.payload);
      if (timeSlots?.length > 0) {
        timeSlots[0].isSelected = true;
        state.delivery.selectedDeliveryDate = {year: timeSlots[0].year, month: timeSlots[0].month, day: timeSlots[0].day};
        if (timeSlots[0].hours?.length > 0) {
          timeSlots[0].hours[0].isSelected = true;
          state.delivery.selectedDeliveryDate.startDate = timeSlots[0].hours[0].startDate;
          state.delivery.selectedDeliveryDate.endDate = timeSlots[0].hours[0].endDate;
          state.delivery.selectedDeliveryDate.round = timeSlots[0].hours[0].round;
          state.delivery.selectedDeliveryTimeDisplay = getTechnicianTimeDisplay(
            timeSlots[0].hours[0].startDate,
            timeSlots[0].hours[0].endDate,
          );
          state.delivery.titleDeliveryPage = getTechnicianTimeDisplay(timeSlots[0].hours[0].startDate, timeSlots[0].hours[0].endDate);
        }
      }
      state.delivery.timeSlots = timeSlots;
    },
    [emailIsExist.fulfilled]: (state, action) => {
      state.isEmailAvailable = action.payload;
    },
    [createWorkOrder.fulfilled]: (state, action) => {},
    [createLead.fulfilled]: (state, action) => {},
    [checkWhatsAppActivity.fulfilled]: (state, action) => {
      state.isWhatsAppActive = action.payload?.Body && state.saleBlockData.isDisplayWhatsAppWhenNoFiber;
    },
    [getPhoneNumbers.fulfilled]: (state, action) => {
      let current = state.cellular.cellularSettingsList.find((x) => x.isSelected);
      current.newPhoneNumbers = action.payload;
    },
    [getPhoneNumberInfo.fulfilled]: (state, action) => {
      let current = state.cellular.cellularSettingsList.find((x) => x.isSelected);
      current.transferPhoneNumberInfo.isCellcomPhone = action.payload.phoneOperatorName == 'CELL';
      current.transferPhoneNumberInfo.isGolanPhone = action.payload.phoneOperatorName == 'GTEL';
      current.transferPhoneNumberInfo.phoneNumber = current.phoneNumber;
    },
    [reservePhone.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        let current = state.cellular.cellularSettingsList.find((x) => x.isSelected);
        current.reservePhoneInfo.phoneNumber = current.phoneNumber;
      }
    },
    [getPriceSim.fulfilled]: (state, action) => {
      let simPriceExist = state.cellular.simPriceList.find((x) => x.bpKey == action.payload?.bpKey);
      if (simPriceExist) {
        simPriceExist.esim = action.payload[getEsimTypeCode()],
        simPriceExist.sim = action.payload[getSimTypeCode()];
      } else {
        let simPrice = {
          bpKey: action.payload?.bpKey,
          esim: action.payload[getEsimTypeCode()],
          sim: action.payload[getSimTypeCode()],
        };
        state.cellular.simPriceList.push(simPrice);
      }
    },
    [getFullPrice.fulfilled]: (state, action) => {
      if (state.saleType == 'cellular') {
        state.cellular.shoppingCart = action.payload;
      } else {
        state.shoppingCart = action.payload;
      }
      const summaryDetails = buildSummaryDetails(state);
      state.summaryDetails = summaryDetails;
    },
  },
});

export const {
    resetBlock,
    initSale,
    goToPage,
    syncPageNavigationState,
    setSaleType,
    setFlowType,
    setOrderType,
    setUserAddressesForUpgrade,
    reportAnalytics,
    reportTagManager,
    setErrorPage,
    setErrorText,
    setOtpDetails,
    setIsSubmit,
    clearAutoPrepareSale,
    setSelectedAddress,
    updateConverter,
    updateAddons,
    setOtpAttempts,
    setOtpTicketId,
    setOtpErrorMsg,
    setOtpRestrictCodeError,
    setTechnicianDay,
    setTechnicianSelectedTime,
    setEntries,
    setSelectedEntry,
    setSelectedRouter,
    setCancelRouter,
    setSelectedInternetSpeed,
    setSelectedSuperWifi,
    setSelectedSuperWifiReplace,
    setPersonalInfo,
    setSelectedPackage,
    setIsLoadingShoppingCart,
    setUserAddresses,
    setSelectedUserAddress,
    setSelectedUserAddressForUpgrade,
    setPremiumPackageChanged,
    resetPremiumPackage,
    setEmail,
    setIsEmailAvailable,
    resetCgIframeUrl,
    setSupplyType,
    setTechnicianPrice,
    setDeliveryPrice,
    setDeliveryAddress,
    setDeliveryTimeSlots,
    setDeliveryDate,
    setSelectedDeliveryDay,
    setSelectedDeliveryTime,
    setIsReceivingAd,
    setIsCalcSupplyMethod,
    setTechnicianContact,
    // filterSalePackages,
    setShowPopUpRouter,
    setLeadPage,
    reportDWH,
    setIsOccupiedTechnicianSlot,
    setTotalPrice,
    setSalePackages,
    setPackageNotValidPopUp,
    setIdentitySuccessPopup,
    setInternetExistingInternetChoicePopup,
    setCellularSetting,
    setSelectedAddOn,
    setCellularSettingList,
    resetCellularSettingsPage,
    setCellularServices,
    onClickCellularItem,
    setIsDisplayPackageUpgradePopUp,
    resetCellularTransferPhoneNumberInfo,
    updateSelectedCellularSettings,
    setSupplyByPost,
    setDisplaySubscriberBasedPackage,
    setResultByOrders,
    setSummaryDetails,
    editRemoveCellular,
    setIsDisplayShoppingCart,
    setIsShoppingCartOpen,
    removeCellularItem,
    setProductWorldList,
    removeProductWorldListEntry,
    setFamilyMemberInfo,
    setSelectedEsimLine,
    setAdditionalResultValue
} = saleJetBlockSlice.actions;

export default saleJetBlockSlice.reducer;

const getAllPremiumPackages = (saleCatalog) => {
  let premiumPackagesResponse = [];

  saleCatalog?.premiumPackages?.map((premiumPackage) => {
    if (premiumPackage.isPremiumPackagesWorld) {
      premiumPackage.priceItemList = buildPriceItemList(premiumPackage.priceItemList);
      premiumPackage.premiumPackages = premiumPackage.premiumPackages.filter(
        (x) => x.vasList == null && x.cmsData != null && !x.cmsData.isHidden,
      );
      if (premiumPackage.premiumPackages?.length > 1) {
        premiumPackage.premiumPackages?.map((premiumPackageInWorld) => {
          premiumPackageInWorld.priceItemList = buildPriceItemList(premiumPackageInWorld.priceItemList);
        });
        premiumPackage.isSelected = premiumPackage.premiumPackages.some((x) => x.action.toUpperCase() == 'ADD');
        premiumPackagesResponse.push(premiumPackage);
      }
    } else {
      if (premiumPackage.cmsData) {
        premiumPackage.priceItemList = buildPriceItemList(premiumPackage.priceItemList);
        premiumPackagesResponse.push(premiumPackage);
      }
    }
  });

  premiumPackagesResponse = premiumPackagesResponse?.filter((premiumPackage) => {
    if (premiumPackage.isPremiumPackagesWorld) {
      return true;
    } else {
      let isInWorld = premiumPackagesResponse.some(
        (x) => x.isPremiumPackagesWorld && x.premiumPackages?.some((x) => x.name == premiumPackage.name),
      );
      return !isInWorld;
    }
  });

  return premiumPackagesResponse;
};

function getSaleTypeName(saleType) {
  switch (Number(saleType)) {
    case 0:
      return 'tv';
    case 1:
      return 'app';
    case 2:
      return 'cellular';
    case 3:
      return 'internet';
    case 4:
      return 'triple';
    case 5:
      return 'landline';
    default:
      return 'tv';
  }
}

function getProgressBarPoints(saleType, flowType) {
  const pages = salePages[saleType]?.[flowType];
  if (!pages) {
    return [];
  }
  let progressBarPoints = pages.map(function (item) {
    return item['percent'];
  });
  return progressBarPoints;
}

function getCustomTechnicianTimes(technicianTimesList) {
  if (!technicianTimesList) {
    return;
  }

  const groups = technicianTimesList.reduce((groups, item) => {
    const date = item.start.split('T')[0];
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(item);
    return groups;
  }, {});

  const groupArrays = Object.keys(groups).map((date) => {
    return {
      date,
      hours: groups[date],
    };
  });

  let technicianTimes = [];

  groupArrays.forEach((item) => {
    let currentDate = new Date(item.date);
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let monthName = getMonthName(currentDate.getMonth());
    let day = currentDate.getDate();
    let dayOfWeek = getDayOfWeek(currentDate.getDay());
    let hours = [];

    item.hours.forEach((hour) => {
      let startDate = new Date(hour.start);
      let endDate = new Date(hour.end);

      const hourItem = {
        startDate: hour.start,
        endDate: hour.end,
        start: ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2),
        end: ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2),
        isSelected: false,
      };

      hours.push(hourItem);
    });

    let technicianTime = {
      year: year,
      month: month,
      monthName: monthName,
      day: day,
      dayOfWeek: dayOfWeek,
      hours: hours,
      isSelected: false,
    };

    technicianTimes.push(technicianTime);
  });

  return technicianTimes;
}

function getMonthName(month) {
  const monthNames = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
  return monthNames[month];
}

function getDayOfWeek(dayOfWeek) {
  const weekDays = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  return weekDays[dayOfWeek];
}

function getTechnicianTimeDisplay(start, end) {
  let startDate = new Date(start);
  let endDate = new Date(end);

  const dayOfWeek = getDayOfWeek(startDate.getDay());
  const dateToDisplay = formatDate(startDate);

  const startHour = ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2);
  const endHour = ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2);

  let selectedTechnicianTimeDisplay = `${dayOfWeek} ${dateToDisplay} בין ${startHour}-${endHour}`;
  return selectedTechnicianTimeDisplay;
}

function formatDate(date) {
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  const dateToDisplay = dd + '.' + mm + '.' + yyyy;
  return dateToDisplay;
}

function deliveryTimeSlotsFormat(timeSlots) {
  if (!timeSlots) {
    return;
  }

  const groupsByDate = timeSlots.reduce((groups, item) => {
    const date = item.lfdat;
    if (!groups[date]) {
      groups[date] = {date: date, hours: []};
    }
    groups[date].hours.push({start: item.waitFrom, end: item.waitTo, round: item.round});
    return groups;
  }, []);

  let timeSlotsRes = [];

  Object.keys(groupsByDate).map((key) => {
    const item = groupsByDate[key];
    let currentDate = new Date(item.date);
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let monthName = getMonthName(currentDate.getMonth());
    let day = currentDate.getDate();
    let dayOfWeek = getDayOfWeek(currentDate.getDay());
    let hours = [];

    item.hours.forEach((hour) => {
      const hourItem = {
        startDate: item.date + 'T' + hour.start,
        endDate: item.date + 'T' + hour.end,
        round: hour.round,
        start: hour.start.slice(0, 5),
        end: hour.end.slice(0, 5),
        isSelected: false,
      };

      hours.push(hourItem);
    });

    let technicianTime = {
      year: year,
      month: month,
      monthName: monthName,
      day: day,
      dayOfWeek: dayOfWeek,
      hours: hours,
      isSelected: false,
    };

    timeSlotsRes.push(technicianTime);
  });

  return timeSlotsRes;
}


function daysBetweenTwoDates(date1, date2) {
  try {
    return Math.ceil(Math.abs(date1 - date2) / (1000 * 60 * 60 * 24));
  } catch (error) {
    return 0;
  }
}

function getPrice(price) {
  return price ? price : 0;
}

// function getPremiumPackagesVasList(premiumPackages) {
//   let vasList = [];
//   if (!premiumPackages || premiumPackages.length == 0) {
//     return vasList;
//   }
//   premiumPackages.map(function (item) {
//     item.vasList?.map(function (vas) {
//       if (vas.duration.amount != 0 && vas.action?.toUpperCase() == 'ADD') {
//         vasList.push(vas);
//       }
//     });
//   });
//   return vasList;
// }

// function getPremiumPackages(premiumPackages) {
//   let premiumPackageList = [];

//   premiumPackages?.map(function (item) {
//     if (item.isPremiumPackagesWorld) {
//       item.premiumPackages?.map(function (premiumPackage) {
//         if (premiumPackage.action?.toUpperCase() == "ADD") {
//           premiumPackageList.push(premiumPackage);
//         }
//       });
//     }
//     else {
//       if (item.action?.toUpperCase() == "ADD") {
//         premiumPackageList.push(item);
//       }
//     }
//   });
//   return premiumPackageList;
// }

function getOneTimePriceList(state) {
  let oneTimePriceList = [];

  state.saleCatalog.premiumPackages?.map(function (item) {
    item.vasList?.map(function (vas) {
      if (vas.duration.amount != 0 && vas.action?.toUpperCase() == 'ADD') {
        let oneTimePrice = {name: vas.billDescription, price: parseFloat(vas.price)};
        oneTimePriceList.push(oneTimePrice);
      }
    });
  });

  state.saleCatalog?.supplyMethods?.map(function (item) {
    if (state.supplyType == 'technician' && item.name == 'Technician' && getPrice(item.price) > 0) {
      let oneTimePrice = {name: 'ביקור טכנאי', price: item.price};
      oneTimePriceList.push(oneTimePrice);
    }
    if (state.supplyType == 'delivery' && item.name == 'Delivery' && getPrice(item.price) > 0) {
      let oneTimePrice = {name: 'שליחות', price: item.price};
      oneTimePriceList.push(oneTimePrice);
    }
  });

  const pavingFee = state.saleCatalog.pavingFee;
  if (pavingFee?.price && parseFloat(pavingFee.price) > 0) {
    let oneTimePrice = {
      name: `דמי פריסה <span style="display:inline-block;">ב-${pavingFee.numberOfInstallments} תשלומים</span>`,
      price: pavingFee.price,
    };
    oneTimePriceList.push(oneTimePrice);
  }
  return oneTimePriceList;
}

function getTotalPriceOneTime(oneTimePriceList) {
  try {
    const totalPriceOneTime = oneTimePriceList.reduce((accumulator, item) => {
      return accumulator + item.price;
    }, 0);
    return parseFloat(totalPriceOneTime);
  } catch (error) {
    return 0;
  }
}

// function groupConvertersByPrice(converterList) {
//   let groupArrays = [];
//   const groups = converterList?.reduce((groups, item) => {
//     if (!groups[item.price]) {
//       groups[item.price] = [];
//     }
//     groups[item.price].push(item);
//     return groups;
//   }, {});

//   if(groups){
//   groupArrays = Object.keys(groups).map((price) => {
//     return {
//       price: price * groups[price].length,
//       cmsData: groups[price][0]?.cmsData,
//       count: groups[price].length,
//     };
//   });
//   }

//   return groupArrays;
// }

// function groupAddOnsByName(addonList) {
//   let groupArrays = [];
//   const groups = addonList?.reduce((groups, item) => {
//     const key = item.name + '_' + item.price;
//     if (!groups[key]) {
//       groups[key] = [];
//     }
//     groups[key].push(item);
//     return groups;
//   }, {});

//   if (groups) {
//     groupArrays = Object.keys(groups).map((key) => {
//       return {
//         key,
//         cmsData: groups[key][0]?.cmsData,
//         count: groups[key].length,
//         localizedName: groups[key][0]?.localizedName,
//         price: groups[key][0]?.price * groups[key].length ,
//         originalPrice: groups[key][0]?.originalPrice * groups[key].length,
//         priceItemList: groups[key][0]?.priceItemList.map(x => {x.price =  x.price * groups[key].length; return x}),
//       };
//     });
//   }

//   return groupArrays;
// }

function buildCellularServicesCodes(cellularServices) {
  let cellularServicesCodes = [];
  if (cellularServices != null && Object.keys(cellularServices).length !== 0) {
    cellularServicesCodes.push({name: 'GIS1', configuredvalue: cellularServices.ONE_TIME ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'GIS2', configuredvalue: cellularServices.ONE_TIME ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'GIS3', configuredvalue: cellularServices.ONE_TIME ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'GIS4', configuredvalue: cellularServices.ONE_TIME ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'GIS5', configuredvalue: cellularServices.ONE_TIME ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'GIS6', configuredvalue: cellularServices.CONTINUAL ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'GIS7', configuredvalue: cellularServices.CONTINUAL ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'GIS8', configuredvalue: cellularServices.ABROAD ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'PRE0', configuredvalue: cellularServices.PREMIUM ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'PRE1', configuredvalue: cellularServices.PREMIUM ? 'Y' : 'N'});
    cellularServicesCodes.push({name: 'OFOR', configuredvalue: cellularServices.SERVICE_144 ? 'Y' : 'N'});
  } else {
    cellularServicesCodes.push({name: 'GIS1', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'GIS2', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'GIS3', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'GIS4', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'GIS5', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'GIS6', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'GIS7', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'GIS8', configuredvalue: 'Y'});
    cellularServicesCodes.push({name: 'PRE0', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'PRE1', configuredvalue: 'N'});
    cellularServicesCodes.push({name: 'OFOR', configuredvalue: 'N'});
  }
  return cellularServicesCodes;
}

function resetCellularServices() {
  return {ONE_TIME: false, CONTINUAL: false, PREMIUM: false, ABROAD: true, SERVICE_144: false};
}


function buildSummaryDetails(state) {
  let selectedAddress = state.addressPage?.selectedAddress;
  let productsCount = 0;
  var oneTimePriceList = [];
  let totalPriceOneTime = 0;

  //----------------shoppingCart---------------
  if (state.saleType == 'cellular') {
    selectedAddress = state.delivery?.selectedAddress;
    var orderPrices = [];
    var oneTimePrices = [];

    state.cellular.cellularSettingsList?.forEach((item, index) => {
      let cellular = state.cellular.shoppingCart?.orderPrices?.find((x) => x.phoneNumber == item.phoneNumber);
      if (cellular) {
        cellular.phoneNumberFormat = item.phoneNumberFormat;
        cellular.package = {title: item.package.title};
        orderPrices.push(cellular);

        var oneTimeObj = {
          phoneNumberFormat : item.phoneNumberFormat,
          phoneNumber : item.phoneNumber,
          simType: item.simType,
          oneTimePriceObjList : []
        }

        if (item.simType && item.orderId) {
          const simObj = state.cellular.simPriceList.find((x) => x.bpKey == item.bpKey);
          const simPrice = (item.simType == 'SIM' || item.simType == 'SIMG') ? simObj.sim : simObj.esim;
          const priceText = (item.simType == 'SIM' || item.simType == 'SIMG') ? 'כרטיס SIM' : 'כרטיס eSIM';
          const obj = {
            price: simPrice,
            priceText: priceText,
          };
          oneTimeObj.oneTimePriceObjList.push(obj);
          oneTimePrices.push(obj.price);
        }

        cellular?.onceList?.forEach((item, index) => {
          const obj = {
            price: item.price,
            priceText: item.text,
          }
          oneTimeObj.oneTimePriceObjList.push(obj);
          oneTimePrices.push(obj.price);
        });

        oneTimePriceList.push(oneTimeObj);

      }
    });


    if (state.deliveryPrice && parseFloat(state.deliveryPrice)  > 0) {
      oneTimePriceList.push({
        price: state.deliveryPrice,
        priceText: 'עלות שליחות',
        isDeliveryPrice: true,
      });
      oneTimePrices.push(state.deliveryPrice);
    }

    state.cellular.shoppingCart.orderPrices = orderPrices;
    setCellularItemsPriceText(state.cellular.shoppingCart);
    totalPriceOneTime = oneTimePrices.reduce((total, price) => total + parseFloat(price || 0), 0);
    productsCount = state.cellular.shoppingCart.orderPrices.length;
  } else {
    if (state.supplyType == 'delivery') {
      selectedAddress = state.delivery.selectedAddress;
    }

    if (state.shoppingCart.fullPrice) {
      state.shoppingCart.fullPrice = buildPriceItemList(state.shoppingCart?.fullPrice);
    }
    state.shoppingCart?.orderPrices?.forEach((order, index) => {
      if (order.cartName.toLowerCase() == 'bundel') {
        //tv|app|internet|triple
        order.index = 1;
        order.offerItemList = buildPriceItemList(order.offerItemList);
        order.addonsPrices = [];
        productsCount = productsCount + 1;
      } else {
        const hasBundle = state.shoppingCart?.orderPrices.some((x) => x.cartName.toLowerCase() == 'bundel');
        if (order.cartName.toLowerCase() == 'internet') {
          order.index = 2;
          if (!hasBundle) {
            order.offerItemList = buildPriceItemList(order.offerItemList);
            productsCount = productsCount + 1;
          }
        } else if (order.cartName.toLowerCase() == 'tv') {
          order.index = 3;
          if (!hasBundle) {
            order.offerItemList = buildPriceItemList(order.offerItemList);
            productsCount = productsCount + 1;
          }
        }
        let convertsIndex = 1;
        let superWifiIndex = 1;
        order.addonsPrices?.forEach((addon, index) => {
          addon.priceItemList = buildPriceItemList(addon.priceItemList);
          if (addon.type.toUpperCase() == 'INTERNETSPEED') {
            addon.index = 1;
            addon.title = addon.billDescription;
          } else if (addon.type.toUpperCase() == 'CONVERTERS') {
            addon.index = 2;
            addon.title = 'ממיר ' + (convertsIndex > 1 ? convertsIndex : '');
            convertsIndex = convertsIndex + 1;
            productsCount = productsCount + 1;
          } else if (addon.type.toUpperCase() == 'PREMIUMPACKAGES') {
            addon.index = 3;
            addon.title = addon.billDescription;
            productsCount = productsCount + 1;
          } else if (addon.type.toUpperCase() == 'SUPERWIFI') {
            addon.index = 4;
            addon.title = (superWifiIndex > 1 ? superWifiIndex : '') + ' ' + addon.name;
            superWifiIndex = superWifiIndex + 1;
            productsCount = productsCount + 1;
          } else if (addon.type.toUpperCase() == 'ROUTERS') {
            addon.index = 5;
            addon.title = 'נתב ' + addon.billDescription;
            productsCount = productsCount + 1;
          } else if (addon.type.toUpperCase() == 'MODEMS') {
            addon.index = 6;
            addon.title = addon.billDescription;
            productsCount = productsCount + 1;
          } else {
            addon.index = 7;
            addon.title = addon.billDescription;
            productsCount = productsCount + 1;
          }
        });
        order.addonsPrices.sort((a, b) => a.index - b.index);
      }
    });
    state.shoppingCart?.orderPrices.sort((a, b) => a.index - b.index);

    oneTimePriceList = getOneTimePriceList(state);
    totalPriceOneTime = getTotalPriceOneTime(oneTimePriceList);
    productsCount = productsCount + oneTimePriceList.length;
  }
  //----------------shoppingCart---------------


  const summaryDetails = {
    saleType: state.saleType,
    orderNumber: state.orderNumber,
    selectedTechnicianTimeDisplay: state.technician.selectedTechnicianTimeDisplay,
    selectedDeliveryTimeDisplay: state.delivery.selectedDeliveryTimeDisplay,
    offerName: state.saleCatalog.offerName,
    cellularShoppingCart: state.cellular.shoppingCart,
    shoppingCart: state.shoppingCart,
    oneTimePriceList: oneTimePriceList,
    selectedAddress: selectedAddress,
    personalInfo: state.personalInfo,
    supplyType: state.supplyType,
    totalPriceOneTime: totalPriceOneTime,
    // technicianPrice: state.technicianPrice,
    // deliveryPrice: state.deliveryPrice,
    productsCount: productsCount,
  };
  return summaryDetails;
}


function buildPriceItemList(priceItemList) {
  let priceItems = priceItemList;
  if (priceItems?.length > 0) {
    priceItems?.map((item, index) => {
      if (item.amount) {
        if (parseInt(item.amount) == 1) {
          item.priceText = 'חיוב חודשי לחודש הראשון';
          item.priceTextPremiumPackages = 'לחודש הראשון';
        } else if (parseInt(item.amount) == 2) {
          item.priceText = 'חיוב חודשי לחודשיים הראשונים';
          item.priceTextPremiumPackages = 'לחודשיים הראשונים';
        } else {
          item.priceText = 'חיוב חודשי למשך ' + (item.amount + ' חודשים') + ' ראשונים';
          item.priceTextPremiumPackages = 'ל' + (item.amount + ' חודשים') + ' ראשונים';
        }
      } else if (item.to == 0 && item.from == item.to) {
        //from and to = 0
        item.priceText = '';
      } else if ((item.from == 0 || item.from == 1) && item.from < item.to) {
        const monthsText = ['חודש', 'חודשיים', item.to + ' חודשים'];
        const monthText = item.to == 2 ? monthsText[1] : monthsText[2];
        item.priceText = item.to == 1 ? '' : 'לחודש למשך ' + monthText;
        item.priceTextPremiumPackages = item.to == 1 ? 'לחודש הראשון' : ' ל' + monthText + ' חודשים ';
      } else if (item.to == 0 && item.from > item.to) {
        if (item.from == 1) {
          item.priceText = 'חיוב חודשי';
          item.priceTextPremiumPackages = 'לחודש';
        } else if (item.from == 2) {
          item.priceText = 'חיוב חודשי לאחר חודש';
          item.priceTextPremiumPackages = 'ולאחר מכן';
        } else if (item.from == 3) {
          item.priceText = 'חיוב חודשי לאחר חודשיים';
          item.priceTextPremiumPackages = 'ולאחר מכן';
        } else {
          item.priceText = 'חיוב חודשי החל מ ' + (item.from + ' חודשים');
          item.priceTextPremiumPackages = 'ולאחר מכן';
        }
      } else if (item.to != 0 && item.from < item.to) {
        item.priceText = 'מחודש ' + item.from + ' עד חודש ' + item.to;
        item.priceTextPremiumPackages = 'מחודש ' + item.from + ' עד חודש ' + item.to;
      } else if (item.to != 0 && item.from == item.to) {
        const monthsText = ['ראשון', 'שני', 'שלישי', 'רביעי'];
        item.priceText = 'חיוב חודשי בחודש ה' + (item.from < 4 ? monthsText[item.from - 1] : item.from);
        item.priceTextPremiumPackages = 'חיוב חודשי בחודש ה' + (item.from < 4 ? monthsText[item.from - 1] : item.from);
      }
      return item;
    });
  } else {
    priceItems = [];
  }
  return priceItems;
}

function setCellularItemsPriceText(shoppingCart) {
  if (shoppingCart && shoppingCart?.orderPrices?.length > 0) {
    shoppingCart?.orderPrices?.map((order, index) => {
      order.offerItemList = buildPriceItemList(order?.offerItemList);
      order?.addonsPrices?.map((addons, index) => {
        addons.priceItemList = buildPriceItemList(addons.priceItemList);
        return addons;
      });
      return order;
    });
    shoppingCart.fullPrice = buildPriceItemList(shoppingCart.fullPrice);
  }
}

// function getCellularOneTimePriceList(cellularSettingsList, simPriceList, deliveryPrice) {
//   let oneTimePriceList = [];
//   cellularSettingsList.forEach((item, index) => {
//     if (item.simType && item.orderId) {
//       const simObj = simPriceList.find((x) => x.bpKey == item.bpKey);
//       const simPrice = isSimType(item.simType) ? simObj.sim : simObj.esim;
//       const priceText = isSimType(item.simType) ? 'כרטיס SIM' : 'כרטיס eSIM';
//       const obj = {
//         phoneNumber: item.phoneNumber,
//         phoneNumberFormat: item.phoneNumberFormat,
//         simType: item.simType,
//         price: simPrice,
//         priceText: priceText,
//       };
//       oneTimePriceList.push(obj);
//     }
//   });
//   if (deliveryPrice && parseFloat(deliveryPrice)  > 0) {
//     oneTimePriceList.push({
//       price: deliveryPrice,
//       priceText: 'עלות שליחות',
//       isDeliveryPrice: true,
//     });
//   }
//   return oneTimePriceList;
// }
